// DEPENDENCIES ---------------------------------------------------------------- //

import { Theme } from '@mui/material';

// TYPES ---------------------------------------------------------------- //

export type ChartColors = {
  completed: string;
  pending: string;
  canceled: string;
  assigned: string;
  validated: string;
  neutral: string;
};

// HELPERS ---------------------------------------------------------------- //

/**
 * Chart palette derived from the MUI theme. Do not invent new brand colors.
 *
 * Aligned with the HopDrive design system's dataViz ordering:
 *  - secondaryAccent (#4068a0) is the canonical primary data-series color (dataViz[0])
 *  - tertiaryAccent (#40a0b0) is dataViz[1]
 *  - primaryAccent (#ff4830) is reserved for CTAs/chips, NOT large chart fills, so it is
 *    intentionally avoided here (it also clashes with the semantic error red used for canceled)
 *  - success/error are kept for their semantic series (completed/canceled)
 *  - warning amber distinguishes pending ("waiting") from the assigned blue
 */
export function getChartColors(theme: Theme): ChartColors {
  return {
    completed: theme.palette.success.main,
    pending: theme.palette.warning.main,
    canceled: theme.palette.error.main,
    assigned: theme.palette.secondary.main,
    validated: theme.palette.tertiary.main,
    neutral: theme.palette.grey[500],
  };
}
